<template>
<div>
    <v-container
    style="padding-top:0"
     :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''">
      <v-row>
        <v-col md="8" style="padding:8px">
          <Section0 />
          <Section1 />
        </v-col>

        <v-col md="4" style="padding:8px;">
          <Section2 />
          <Section3 class="mt-4" />
          <Section4 class="mt-4" />
        </v-col>
      </v-row>
    </v-container>

    <v-container
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-expansion-panels flat style="padding:0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon class="mr-2">play_circle_outline</v-icon>Watch tutorials
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" style="padding:8px 8px 8px 8px" class="text-center">
                <vimeo-player video-id="416293848" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
 
</template>

<script>
import Section0 from "./Section0";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
//import Section3 from "./Section3";

export default {
  name: "Pool",
  components: {
    Section0,
    Section1,
    Section2,
    Section3,
    Section4
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    senMessage() {}
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style>
</style>